'use strict';
const angular = require('angular');

/*@ngInject*/
export function DocumentService($resource) {

  return $resource('/api/documents/:id', {
    id: '@_id'
  },{
    getByType: {
      method: 'GET',
      url: "/api/documents/type/:type",
      isArray: true
    },
    queryPublic: {
      method: 'GET',
      url: "/api/documents/public",
      isArray: true
    },
    getNewest: {
      method: 'GET',
      url: "/api/documents/newest/:count",
      isArray: true
    },
    patch: {
      method: 'PATCH'
    }
  });

}

export default angular.module('conduuApp.DocumentService', [])
  .factory('DocumentService', DocumentService)
  .name;



// WEBPACK FOOTER //
// ./client/services/document/document.service.js